import { GoodsPartnerLandingPage } from './GoodsPartnerLandingPage.ts';

export const goodsPartnerLandingRouter = {
  '/@/goodspartner': GoodsPartnerLandingPage,
};
